__turbopack_context__.v({
  "className": "_8NZH0q_className",
  "variable": "_8NZH0q_variable",
});
